module.exports = __webpack_public_path__ + "media/images/calendar-b08b10d9c6317dc836974553ebe37257.png";